<template>
  <div>
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        cols="12"
        md="12"
      >
        <b-row class="breadcrumbs-top">
          <b-col
            class="content-header-left mb-2"
            cols="12"
            md="12"
          >
            <b-row class="breadcrumbs-top">
              <b-col cols="12">
                <h1
                  class="custom-header-title"
                >
                  {{ request.stringID }} - {{ request.originalPurchaser ? request.originalPurchaser.name : '' }}
                </h1>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <section class="invoice-preview-wrapper">
      <b-row class="invoice-preview">
        <!-- Col: Left (Invoice Container) -->
        <!-- Right Col: Card -->
        <b-col
          cols="12"
          md="4"
          xl="3"
          class="invoice-actions"
        >
          <div
            class="user_block ac_type mb-2"
            style="float: none;"
          >
            <div class="user_avatar" />
            <div class="user_info">
              <h6>Status</h6>
              <h5 class="text-capitalize">
                {{ request.currentStatus }}
              </h5>
            </div>
          </div>
          <b-card v-if="request.currentStatus == 'Awaiting Approval' || request.currentStatus == 'Pending NP'">
            <template #header>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="button"
                variant="flat-primary"
                class="primary-button-with-background mr-3"
              >
                <feather-icon
                  icon="CheckCircleIcon"
                  class="white-color"
                  size="20"
                />
              </b-button>
              <h3 class="align-middle mr-auto">
                Ready to Approve?
              </h3>
            </template>
            <span>
              You may approve this customer request once you have reviewed the relevant information.
            </span>

            <!-- Button: Send Invoice -->
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="success"
              class="mb-75 mt-2"
              block
              :disabled="request.currentStatus == 'Pending NP' || !canViewThisAction('approve', 'ChangePurchaser')"
              @click="approveRequest"
            >
              <feather-icon
                icon="CheckIcon"
                class="mr-50"
                size="16"
              />
              <span class="align-middle">Approve</span>
            </b-button>
            <div class="d-flex">
              <b-button
                v-if="request.currentStatus == 'Awaiting Approval' && canViewThisAction('reject', 'ChangePurchaser')"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="flat-danger"
                class="mb-75"
                block
                @click="rejectRequest"
              >
                <feather-icon
                  icon="XIcon"
                  class="mr-50"
                  size="16"
                />
                <span class="align-middle">Reject</span>
              </b-button>
              <b-button
                v-if="canViewThisAction('withdraw-op', 'ChangePurchaser')"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="flat-primary"
                class="mb-75"
                block
                @click="withdrawRequest"
              >
                <feather-icon
                  icon="RotateCcwIcon"
                  class="mr-50"
                  size="16"
                />
                <span class="align-middle">Withdraw by OP</span>
              </b-button>
            </div>
          </b-card>
        </b-col>
        <b-col
          cols="12"
          xl="9"
          md="8"
        >
          <b-card
            no-body
            class=""
          >
            <b-card-header style="padding-bottom: 0 !important; border-bottom: none;">
              <b-card-title class="custom-header-title">
                {{ titleText }}
              </b-card-title>
            </b-card-header>
            <b-card-body>
              <b-row>
                <b-col
                  cols="12"
                  md="12"
                >
                  <b-card
                    class="custom-bg-card-ft mb-50"
                    :title="relatedFiles.length ? 'Main file details' : 'File details'"
                  >
                    <b-table-simple
                      borderless
                      responsive
                      class="particulars_of_deceased small-padding-table d-none d-md-block mt-1 mb-0"
                    >
                      <b-tbody>
                        <b-tr>
                          <b-th width="19%">
                            File No.
                          </b-th>
                          <b-td>
                            <div class="text-nowrap">
                              <b-button
                                v-if="canViewThisAction('show', 'File')"
                                v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                                variant="link"
                                class="weight-600 text-bold align-middle detail-view-id"
                                :to="{ name: 'customers-files-show', params: { id: request.fileID || '0' } }"
                              >
                                {{ request.fileNo }}
                              </b-button>
                              <b-button
                                v-else
                                v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                                variant="link"
                                class="weight-600 text-bold align-middle detail-view-id not-button"
                              >
                                {{ request.fileNo }}
                              </b-button>
                            </div>
                          </b-td>
                          <b-th width="19%">
                            File Status
                          </b-th>
                          <b-td>
                            <span
                              class="text-capitalize weight-600"
                              :class="`text-${resolveFileStatusVariant(request.nvsFileStatus)}`"
                            >
                              {{ request.nvsFileStatus }}
                            </span>
                          </b-td>
                        </b-tr>
                        <b-tr>
                          <b-th width="19%">
                            Product
                          </b-th>
                          <b-td>
                            <span>{{ request.nvsFileType }}</span>
                          </b-td>
                          <b-th width="19%">
                            Payment Status
                          </b-th>
                          <b-td>
                            <span
                              class="text-capitalize weight-600"
                              :class="`text-${resolvePaymentStatusVariant(request.paymentStatus)}`"
                            >
                              {{ request.paymentStatus }}
                            </span>
                          </b-td>
                        </b-tr>
                        <b-tr>
                          <b-th width="19%">
                            Lot No.
                          </b-th>
                          <b-td>
                            <span>{{ request.lotLocation }}</span>
                          </b-td>
                          <b-th width="19%">
                            Need Type
                          </b-th>
                          <b-td>
                            <span>{{ request.needType }}</span>
                          </b-td>
                        </b-tr>
                        <b-tr>
                          <b-th
                            class="padding-bottom-0"
                            width="19%"
                          >
                            Lot Type
                          </b-th>
                          <b-td class="padding-bottom-0">
                            <span>{{ request.lotType }}</span>
                          </b-td>
                          <b-th
                            class="padding-bottom-0"
                            width="19%"
                          >
                            Earliest Interment Date
                          </b-th>
                          <b-td class="padding-bottom-0">
                            <span>{{ lotDetail.intermentDate ? dateFormat(lotDetail.intermentDate) : 'Immediate' }}</span>
                          </b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                    <hr>

                    <b-table-simple
                      borderless
                      responsive
                      class="particulars_of_deceased small-padding-table d-none d-md-block mb-0"
                    >
                      <b-tbody>
                        <b-tr>
                          <b-th width="19%">
                            Service Agent Name
                          </b-th>
                          <b-td>
                            <span>{{ request.originalAgent && request.originalAgent.name }}</span>
                          </b-td>
                        </b-tr>
                        <b-tr>
                          <b-th
                            class="padding-bottom-0"
                            width="19%"
                          >
                            Service Agent Code
                          </b-th>
                          <b-td class="padding-bottom-0">
                            <span>{{ request.originalAgent && request.originalAgent.code }}</span>
                          </b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                  </b-card>

                  <b-card
                    v-if="relatedFiles.length"
                    title="Related Files"
                    class="custom-bg-card-ft"
                  >
                    <b-card-text class="mt-75">
                      <RelatedFilesList :related-files="relatedFiles" />
                    </b-card-text>
                  </b-card>
                </b-col>
              </b-row>
              <b-row>
                <b-col
                  cols="12"
                  md="12"
                >
                  <div class="d-flex mt-2 mb-2">
                    <b-card-title class="custom-header-title">
                      Transferor and Transferee Details
                    </b-card-title>
                    <b-button
                      v-if="request.currentStatus == 'Awaiting Approval' && canViewThisAction('edit', 'ChangePurchaser')"
                      variant="link"
                      class="btn-icon rounded-circle ml-auto mr-1 flat-primary-bg"
                      @click="openEditModal"
                    >
                      <feather-icon icon="EditIcon" /> Edit
                    </b-button>
                  </div>
                  <b-table-simple
                    borderless
                    responsive
                    class="particulars_of_deceased small-padding-table d-none d-md-block mb-0"
                  >
                    <b-tbody>
                      <b-tr>
                        <b-th width="20%">
                          Name
                        </b-th>
                        <b-td>
                          <b-button
                            v-if="canViewThisAction('show', 'Customer')"
                            v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                            variant="link"
                            class="weight-600 align-middle detail-view-id"
                            :to="{ name: 'customers-customers-show', params: { id: originalPurchaser.customer ? originalPurchaser.customer._id : '0' } }"
                          >
                            {{ originalPurchaser.name }}
                          </b-button>
                          <b-button
                            v-else
                            v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                            variant="none"
                            class="text-bold-black align-middle detail-view-id not-button"
                          >
                            {{ originalPurchaser.name }}
                          </b-button>
                        </b-td>
                        <td>
                          <feather-icon
                            icon="ArrowRightIcon"
                            size="18"
                            class="align-middle text-body"
                          />
                        </td>
                        <b-td>
                          <span>{{ (request.newPurchaser && request.newPurchaser.name) || '-' }}</span>
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-th width="20%">
                          NRIC
                        </b-th>
                        <b-td>
                          <span>{{ originalPurchaser.nric || '-' }}</span>
                        </b-td>
                        <td>
                          <feather-icon
                            icon="ArrowRightIcon"
                            size="18"
                            class="align-middle text-body"
                          />
                        </td>
                        <b-td>
                          <span>{{ (request.newPurchaser && request.newPurchaser.nric) || '-' }}</span>
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-th width="20%">
                          Date of Birth
                        </b-th>
                        <b-td>
                          <span>{{ (originalPurchaser.customer && originalPurchaser.customer.dob) ? dateFormat(originalPurchaser.customer.dob) : '-' }}</span>
                        </b-td>
                        <td>
                          <feather-icon
                            icon="ArrowRightIcon"
                            size="18"
                            class="align-middle text-body"
                          />
                        </td>
                        <b-td>
                          <span>{{ (request.npInformation && request.npInformation.dob) ? dateFormat(request.npInformation.dob) : '-' }}</span>
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-th width="20%">
                          Sex
                        </b-th>
                        <b-td>
                          <span>{{ (originalPurchaser.customer && originalPurchaser.customer.sex) ? originalPurchaser.customer.sex : '-' }}</span>
                        </b-td>
                        <td>
                          <feather-icon
                            icon="ArrowRightIcon"
                            size="18"
                            class="align-middle text-body"
                          />
                        </td>
                        <b-td>
                          <span>{{ (request.npInformation && request.npInformation.sex) ? request.npInformation.sex : '-' }}</span>
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-th width="20%">
                          Nationality
                        </b-th>
                        <b-td>
                          <span>{{ (originalPurchaser.customer && originalPurchaser.customer.nationality) ? originalPurchaser.customer.nationality : '-' }}</span>
                        </b-td>
                        <td>
                          <feather-icon
                            icon="ArrowRightIcon"
                            size="18"
                            class="align-middle text-body"
                          />
                        </td>
                        <b-td>
                          <span>{{ (request.npInformation && request.npInformation.nationality) ? request.npInformation.nationality : '-' }}</span>
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-th width="20%">
                          Email Address
                        </b-th>
                        <b-td>
                          <span>{{ originalPurchaser.email || '-' }}</span>
                        </b-td>
                        <td>
                          <feather-icon
                            icon="ArrowRightIcon"
                            size="18"
                            class="align-middle text-body"
                          />
                        </td>
                        <b-td>
                          <span>{{ (request.newPurchaser && request.newPurchaser.email) || '-' }}</span>
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-th width="20%">
                          Mobile No.
                        </b-th>
                        <b-td>
                          <span>{{ originalPurchaser.contact || '-' }}</span>
                        </b-td>
                        <td>
                          <feather-icon
                            icon="ArrowRightIcon"
                            size="18"
                            class="align-middle text-body"
                          />
                        </td>
                        <b-td>
                          <span>{{ (request.newPurchaser && request.newPurchaser.contact) || '-' }}</span>
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-th width="20%">
                          Residential address
                        </b-th>
                        <b-td>
                          <span>{{ formatAddress(originalPurchaser.customer && originalPurchaser.customer.perAddress1, originalPurchaser.customer && originalPurchaser.customer.perAddress2, originalPurchaser.customer && originalPurchaser.customer.perCountry, originalPurchaser.customer && originalPurchaser.customer.perPostcode) }}</span>
                        </b-td>
                        <td>
                          <feather-icon
                            icon="ArrowRightIcon"
                            size="18"
                            class="align-middle text-body"
                          />
                        </td>
                        <b-td>
                          <span>{{ formatAddress(request.npInformation && request.npInformation.perAddress1, request.npInformation && request.npInformation.perAddress2, request.npInformation && request.npInformation.perCountry, request.npInformation && request.npInformation.perPostcode) }}</span>
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-th width="20%">
                          Mailing address
                        </b-th>
                        <b-td>
                          <span>{{ formatAddress(originalPurchaser.customer && originalPurchaser.customer.corAddress1, originalPurchaser.customer && originalPurchaser.customer.corAddress2, originalPurchaser.customer && originalPurchaser.customer.corCountry, originalPurchaser.customer && originalPurchaser.customer.corPostcode) }}</span>
                        </b-td>
                        <td>
                          <feather-icon
                            icon="ArrowRightIcon"
                            size="18"
                            class="align-middle text-body"
                          />
                        </td>
                        <b-td>
                          <span>{{ formatAddress(request.npInformation && request.npInformation.corAddress1, request.npInformation && request.npInformation.corAddress2, request.npInformation && request.npInformation.corCountry, request.npInformation && request.npInformation.corPostcode) }}</span>
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-th
                          class="padding-high"
                          width="20%"
                        >
                          Remarks
                        </b-th>
                        <b-td
                          colspan="3"
                          class="padding-high"
                        >
                          <span class="text-bold-black">{{ request.opRemarks || '-' }}</span>
                        </b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                  <hr>
                  <div>
                    <b-card-title class="custom-header-title">
                      Transfer Details
                    </b-card-title>
                  </div>
                  <b-table-simple
                    borderless
                    responsive
                    class="particulars_of_deceased small-padding-table d-none d-md-block"
                  >
                    <b-tbody>
                      <b-tr>
                        <b-th
                          class="padding-high"
                          width="20%"
                        >
                          File Transfer Date
                        </b-th>
                        <b-td
                          colspan="3"
                          class="padding-high"
                        >
                          <span class="">{{ request.transferDate ? dateFormat(request.transferDate) : '-' }}</span>
                        </b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                  <hr>
                  <div>
                    <b-card-title class="custom-header-title">
                      Transfer Fee
                    </b-card-title>
                  </div>
                  <b-table-simple
                    borderless
                    responsive
                    class="particulars_of_deceased small-padding-table d-none d-md-block mb-0"
                  >
                    <b-tbody>
                      <b-tr>
                        <b-th
                          class="padding-high"
                          width="20%"
                        >
                          Transfer Fee
                        </b-th>
                        <b-td
                          colspan="3"
                          class="padding-high"
                        >
                          <span class="">{{ request.transferFee ? `$${numberFormat(request.transferFee)} (Inc. GST)` : '-' }}</span>
                        </b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                  <hr>
                  <template v-if="request.transferType == 'ownership'">
                    <div>
                      <b-card-title class="custom-header-title">
                        Current Lot Value
                      </b-card-title>
                    </div>
                    <b-table-simple
                      borderless
                      responsive
                      class="particulars_of_deceased small-padding-table d-none d-md-block mb-0"
                    >
                      <b-tbody>
                        <b-tr>
                          <b-th
                            class="padding-high"
                            width="20%"
                          >
                            Lot Price
                          </b-th>
                          <b-td
                            colspan="3"
                            class="padding-high"
                          >
                            <span class="">${{ getLotPrice() }}</span>
                          </b-td>
                        </b-tr>
                        <b-tr>
                          <b-th
                            class="border-bottom-th padding-top-th"
                            width="20%"
                          >
                            Maintenance Fee
                          </b-th>
                          <b-td
                            class="border-bottom-td padding-top-td"
                            width="20%"
                          >
                            <span class="">${{ getMaintenanceFee() }}</span>
                          </b-td>
                          <b-td
                            colspan="2"
                          />
                        </b-tr>
                        <b-tr>
                          <b-th
                            class="padding-top-th"
                            width="20%"
                          >
                            Subtotal
                          </b-th>
                          <b-td
                            class="padding-top-td"
                            colspan="3"
                          >
                            <span class="">-</span>
                          </b-td>
                        </b-tr>
                        <b-tr>
                          <b-th
                            class="border-bottom-th"
                            width="20%"
                          >
                            GST 9%
                          </b-th>
                          <b-td
                            class="border-bottom-td"
                            width="20%"
                          >
                            <span class="">-</span>
                          </b-td>
                          <b-td
                            colspan="2"
                          />
                        </b-tr>
                        <b-tr>
                          <b-th
                            class="padding-top-th"
                            width="20%"
                          >
                            Total Value
                          </b-th>
                          <b-td
                            class="padding-top-td"
                            colspan="3"
                          >
                            <span class="">-</span>
                          </b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                    <hr>
                  </template>
                  <div>
                    <b-card-title class="custom-header-title">
                      Agreements
                    </b-card-title>
                  </div>
                  <b-table-simple
                    borderless
                    responsive
                    class="particulars_of_deceased small-padding-table d-none d-md-block mb-0"
                  >
                    <b-tbody>
                      <b-tr>
                        <b-th
                          class="padding-high"
                          width="20%"
                        >
                          Personal Data Consent
                        </b-th>
                        <b-td
                          colspan="3"
                          class="padding-high"
                        >
                          <span class="">{{ request.personalDataConsent ? 'Yes, I agree' : '-' }}</span>
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-th
                          class="padding-top-th"
                          width="20%"
                        >
                          Marketing Consent
                        </b-th>
                        <b-td
                          class="padding-top-td"
                          colspan="3"
                        >
                          <span v-if="!request.marketingDataConsentStep">-</span>
                          <span v-else>
                            {{ request.marketingDataConsent ? 'Opt out of advertising and promotional material' : 'I want to receive advertising and promotional material' }}
                          </span>
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-th
                          width="20%"
                        >
                          Terms and Conditions
                        </b-th>
                        <b-td
                          colspan="3"
                        >
                          <span class="">{{ request.termsConsent ? 'Yes, I agree' : '-' }}</span>
                        </b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                  <hr>
                  <div class="d-flex">
                    <b-card-title class="custom-header-title">
                      Internal Remarks
                    </b-card-title>
                    <b-button
                      v-if="request.internalRemarks && canViewThisAction('edit', 'ChangePurchaser')"
                      variant="link"
                      class="btn-icon rounded-circle ml-auto mr-1 flat-primary-bg"
                      @click="openInternalRemarksEditModal"
                    >
                      <feather-icon icon="EditIcon" /> Edit
                    </b-button>
                  </div>
                  <b-form-textarea
                    v-if="!request.internalRemarks"
                    placeholder="Add Internal Remarks (Optional)"
                    rows="3"
                  />
                  <span v-else>
                    {{ request.internalRemarks ? request.internalRemarks : '-' }}
                  </span>
                  <hr>
                  <div class="d-flex mb-2">
                    <b-card-title class="custom-header-title">
                      Attachments
                    </b-card-title>
                  </div>

                  <input
                    ref="hiddenAllocationFileInput"
                    type="file"
                    multiple
                    capture
                    accept="image/jpeg, image/png, application/pdf"
                    class="d-none"
                    @change="setAttachment"
                  >
                  <b-row v-if="transferAttachments.length">
                    <!-- Content Left -->
                    <b-col
                      v-for="(file, key) in transferAttachments"
                      :key="key"
                      class="content-header-left mb-2"
                      cols="12"
                      md="4"
                    >
                      <div
                        class="attachment-item"
                      >
                        <b-img
                          v-if="file.type.includes('image')"
                          left
                          height="40"
                          :src="require('@/assets/images/admin/doc_jpg.png')"
                          alt="Left image"
                        />
                        <b-img
                          v-if="file.type.includes('application')"
                          left
                          height="40"
                          :src="require('@/assets/images/admin/doc_file.png')"
                          alt="Left image"
                        />
                        <strong>
                          <b-link
                            v-if="file.fileStorage"
                            :to="{ name: 'file-view', params: { id: file.fileStorage } }"
                            target="_blank"
                          >
                            {{ file ? file.name : '' }}
                          </b-link>
                          <b-link
                            v-else-if="file.data"
                            :href="file ? file.data : ''"
                            target="_blank"
                          >
                            {{ file ? file.name : '' }}
                          </b-link>
                        </strong>
                        <span>{{ file ? `${file.size}mb` : '' }}</span>
                        <span class="remove__doc">
                          <b-button
                            v-if="canViewThisAction('edit', 'ChangePurchaser')"
                            variant="flat-primary"
                            @click="removeAttachment(file.name, file._id)"
                          >
                            <feather-icon
                              icon="XIcon"
                              class="mr-50"
                              size="18"
                            />
                          </b-button>
                        </span>
                      </div>
                      <div class="doc__desc new_design">
                        <span v-if="file.description">
                          {{ file.description }}
                        </span>
                        <span v-else>
                          <button
                            v-if="canViewThisAction('edit', 'ChangePurchaser')"
                            @click="updateDescription(key)"
                          >
                            Add a description
                          </button>
                        </span>
                        <span
                          v-if="file.description"
                          class="edit__desc"
                        >
                          <b-button
                            v-if="canViewThisAction('edit', 'ChangePurchaser')"
                            variant="flat-primary"
                            @click="updateDescription(key)"
                          >
                            <feather-icon
                              icon="EditIcon"
                              class="mr-50"
                              size="18"
                            />
                          </b-button>
                        </span>
                      </div>
                    </b-col>
                    <b-col
                      class="content-header-left mb-2"
                      cols="12"
                      md="4"
                    >
                      <b-button
                        v-if="canViewThisAction('edit', 'ChangePurchaser')"
                        variant="link"
                        class="mr-1 md-mb-1"
                        @click="$refs.hiddenAllocationFileInput.click()"
                      >
                        <feather-icon
                          icon="UploadIcon"
                          size="20"
                          class="mr-50"
                        />
                        <span
                          class="align-middle"
                          style="font-weight: 500; font-size: 14px;"
                        >
                          Upload
                        </span>
                      </b-button>
                      <b-button
                        v-if="attachments.length"
                        variant="success"
                        class="mr-1 md-mb-1"
                        @click="uploadFile"
                      >
                        Save File
                      </b-button>
                    </b-col>
                  </b-row>
                  <b-row v-else>
                    <b-col>
                      <div class="empty_block">
                        <h4>Nothing in here yet</h4>
                        <b-button
                          v-if="canViewThisAction('edit', 'ChangePurchaser')"
                          variant="link"
                          class=""
                          @click="$refs.hiddenAllocationFileInput.click()"
                        >
                          <feather-icon
                            icon="UploadIcon"
                            size="20"
                            class="mr-50"
                          />
                          <span
                            class="align-middle"
                            style="font-weight: 500; font-size: 14px;"
                          >
                            Upload
                          </span>
                        </b-button>
                        <b-button
                          v-if="attachments.length"
                          variant="success"
                          class="mr-1 md-mb-1"
                          @click="uploadFile"
                        >
                          Save File
                        </b-button>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>

      <b-card
        class="p-2"
      >
        <b-row
          class="content-header"
        >
          <!-- Content Left -->
          <b-col
            class="content-header-left pb-2"
            cols="12"
            md="12"
          >
            <h4>
              <feather-icon
                icon="ListIcon"
                class="mr-50"
                size="16"
              />
              <span class="align-middle">Activity Logs</span>
            </h4>
          </b-col>
        </b-row>
        <app-timeline>
          <!-- FINANCIAL REPORT -->
          <app-timeline-item
            v-for="(opt, key) in transferDetailActivityLogs"
            :key="key"
            :variant="getVariant(key)"
          >

            <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
              <h6>{{ opt.title }}</h6>
              <small class="text-muted">{{ dateFormatWithTime(opt.time) }}</small>
            </div>
            <b-button
              v-if="opt.activityDetails && opt.activityDetails.length"
              v-b-toggle="'report-list-with-icon-' + key"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              size="sm"
              variant="outline-primary"
            >
              Details
              <feather-icon
                icon="ChevronUpIcon"
                class="ml-50 when-open"
                size="16"
              />
              <feather-icon
                icon="ChevronDownIcon"
                class="ml-50 when-closed"
                size="16"
              />
            </b-button>
            <b-collapse
              v-if="opt.activityDetails && opt.activityDetails.length"
              :id="'report-list-with-icon-' + key"
            >
              <b-table-simple
                borderless
                responsive
              >
                <b-tbody>
                  <b-tr
                    v-for="(activityDetail, activitykey) in opt.activityDetails"
                    :key="activitykey"
                  >
                    <b-th style="width: 300px; max-width: 300px;">
                      {{ activityDetail.title }}
                    </b-th>
                    <b-td>{{ activityDetail.oldValue }}</b-td>
                    <b-td>{{ activityDetail.newValue }}</b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </b-collapse>
          </app-timeline-item>
        </app-timeline>
      </b-card>
    </section>

    <b-modal
      id="modal-update-intended-user"
      ref="update_user_modal"
      modal-class="status-update-modal iu-modal"
      footer-class="iu-edit-modal-footer"
      cancel-variant="flat-primary"
      ok-variant="primary"
      ok-title="Save Changes"
      cancel-title="Cancel"
      centered
      no-close-on-backdrop
      title="Edit Transferee Details"
      size="sm"
      @ok="submitEditForm"
    >
      <b-form @submit.prevent="submitEditForm">
        <validation-observer
          ref="customerEditForm"
        >
          <b-form-group
            label="Email Address"
            label-for="h-iu-npEmail"
          >
            <b-form-input
              id="h-iu-npEmail"
              v-model="npEmail"
              placeholder="michelle1992@gmail.com"
              name="npEmail"
            />
          </b-form-group>
          <b-form-group
            label="Mobile No."
            label-for="h-iu-npContact"
          >
            <b-form-input
              id="h-iu-npContact"
              v-model="npContact"
              placeholder="+65 Enter 8-digits number"
              name="npContact"
            />
          </b-form-group>
          <h5 class="mb-75">
            Edit Mailing Address
          </h5>
          <b-form-group
            label="Address line 1"
            label-for="h-iu-perAdd1"
          >
            <b-form-input
              id="h-iu-perAdd1"
              v-model="perAdd1"
              placeholder="Address Line 1"
              name="perAdd1"
            />
          </b-form-group>
          <b-form-group
            label="Address line 2"
            label-for="h-iu-perAdd2"
          >
            <b-form-input
              id="h-iu-perAdd2"
              v-model="perAdd2"
              placeholder="Address Line 2"
              name="perAdd2"
            />
          </b-form-group>
          <b-form-group
            label="Country"
            label-for="h-iu-perCountry"
          >
            <v-select
              id="h-iu-perCountry"
              v-model="perCountry"
              :options="countryOptions"
              :clearable="false"
              placeholder="Select a country"
            />
          </b-form-group>
          <b-form-group
            label="Postal code"
            label-for="h-iu-perPostcode"
          >
            <b-form-input
              id="h-iu-perPostcode"
              v-model="perPostcode"
              placeholder="Post Code"
              name="perPostcode"
            />
          </b-form-group>
        </validation-observer>
      </b-form>
      <template #modal-footer="{ ok, cancel }">
        <b-button
          variant="outline-primary"
          @click="cancel()"
        >
          Cancel
        </b-button>
        <b-button
          variant="primary"
          @click="ok()"
        >
          <span class="align-middle">Save Changes</span>
        </b-button>
      </template>
    </b-modal>
    <b-modal
      id="modal-attachment-description"
      size="lg"
      title="Attachment Description"
      modal-class="status-update-modal"
      centered
      no-stacking
      header-class="front-modal"
      @ok="saveDescription"
      @cancel="closeDescriptionModal"
    >
      <b-row>
        <b-col md="12">
          <b-form-textarea
            id="h-customer-phone-number"
            v-model="description"
            placeholder="E.g. Receipt Image"
          />
        </b-col>
      </b-row>
      <template #modal-footer="{ ok, cancel }">
        <b-button
          variant="flat-primary"
          @click="cancel()"
        >
          Cancel
        </b-button>
        <b-button
          variant="primary"
          :disabled="!description || attachmentKey === ''"
          @click="ok()"
        >
          <span class="align-middle">Save</span>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="modal-internal-remarks"
      size="sm"
      title="Edit Remarks"
      modal-class="status-update-modal"
      centered
      no-stacking
      header-class="front-modal"
      footer-class="iu-edit-modal-footer"
      @ok="saveInternalRemarks"
      @cancel="closeInternalRemarksModal"
    >
      <b-row>
        <b-col md="12">
          <b-form-textarea
            id="h-customer-phone-number"
            v-model="internalRemarks"
            rows="6"
            placeholder="E.g. Payment Schedule"
          />
        </b-col>
      </b-row>
      <template #modal-footer="{ ok, cancel }">
        <b-button
          variant="outline-primary"
          @click="cancel()"
        >
          Cancel
        </b-button>
        <b-button
          variant="primary"
          :disabled="!internalRemarks"
          @click="ok()"
        >
          <span class="align-middle">Save Changes</span>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { ValidationObserver } from 'vee-validate'
import {
  BCard, BCardHeader, BRow, BButton, BCol, BTableSimple, BTr, BTh, BTd, BTbody, VBTooltip, BForm, BCollapse,
  BCardText, BCardBody, BCardTitle, BFormGroup, BFormInput, BFormTextarea, BImg, BLink, VBToggle,
} from 'bootstrap-vue'
import { required } from '@validations'
import Ripple from 'vue-ripple-directive'
import { useUtils as useAclUtils } from '@/libs/acl/custom'
import store from '@/store/index'
import vSelect from 'vue-select'
// import Cleave from 'vue-cleave-component'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'cleave.js/dist/addons/cleave-phone.us'

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import ToastificationContentCustom from '../../../operation/ToastificationContentCustom.vue'
import RelatedFilesList from './RelatedFiles.vue'

const { canViewThisAction } = useAclUtils()

export default {
  components: {
    BCard,
    BCardHeader,
    BRow,
    BButton,
    BCol,
    BTableSimple,
    BTr,
    BTh,
    BTd,
    BTbody,
    BCardText,
    BCardBody,
    BCardTitle,
    BFormGroup,
    BFormInput,
    BForm,
    BFormTextarea,
    BImg,
    BLink,
    BCollapse,
    // Cleave,
    vSelect,
    ValidationObserver,
    RelatedFilesList,
    AppTimeline,
    AppTimelineItem,
  },
  directives: {
    'b-toggle': VBToggle,
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      canViewThisAction,
      user: store.state.auth.userData,
      internalRemarks: '',
      secondAgree: '',
      npContact: '+65 ',
      npEmail: '',
      perAdd1: '',
      perAdd2: '',
      perCountry: '',
      perPostcode: '',
      corAdd1: '',
      corAdd2: '',
      corCountry: '',
      corPostcode: '',
      countryOptions: ['SINGAPORE', 'MALAYSIA', 'OTHERS'],
      options: {
        prefix: {
          numericOnly: true,
          prefix: '+65',
          blocks: [3, 8],
        },
      },
      required,

      request: {},
      originalPurchaser: {},
      lotDetail: {},
      relatedFiles: [],
      imageUrl: null,
      transferAttachments: [],
      attachments: [],
      description: '',
      attachmentKey: '',
      transferDetailActivityLogs: [],
      titleText: '',
    }
  },
  created() {
    this.$http.get(`customer/transfer-request/${this.$route.params.id}/show`)
      .then(response => {
        this.request = response.data.data
        this.lotDetail = this.request.relatedLot || {}
        if (this.request.transferType === 'ownership') {
          this.titleText = 'Transfer of Ownership Request'
        } else {
          this.titleText = 'Change of Purchaser Request'
        }
        this.transferAttachments = this.request.attachments
        this.transferDetailActivityLogs = this.request.activityLog.sort((a, b) => new Date(b.time) - new Date(a.time))
        this.originalPurchaser = this.request.originalPurchaser
        this.relatedFiles = this.request.relatedFiles
      })
      .catch(error => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  },
  methods: {
    formatAddress(addr1, addr2, country, postcode) {
      const main = [addr1, addr2, country].filter(p => p && p.trim())
      const result = main.join(', ')
      const pc = postcode && postcode.trim()
      if (!result && !pc) return '-'
      return pc ? `${result} ${pc}`.trim() : result
    },
    getLotPrice() {
      let price = 0
      if (this.request.relatedLot) {
        const dspItems = this.request.relatedLot.dspItems || []
        const lotPrice = dspItems.find(item => item.logicCode === 'MAINPRODUCT' && item.needType === this.request.needType)
        if (lotPrice) {
          price = lotPrice.price
        }
      }
      return this.numberFormat(price)
    },
    getMaintenanceFee() {
      let price = 0
      if (this.request.relatedLot) {
        const dspItems = this.request.relatedLot.dspItems || []
        const maintenanceFee = dspItems.find(item => item.logicCode === 'MAINTENANCE' && item.needType === this.request.needType)
        if (maintenanceFee) {
          price = maintenanceFee.price
        }
      }
      return this.numberFormat(price)
    },
    approveRequest() {
      this.internalRemarks = this.request.internalRemarks
      this.$swal({
        title: `Approve this ${this.titleText}?`,
        html: `
    <p class="mb-1">You are going to approve this ${this.titleText}. Are you sure?</p>
    <div style="display: flex; flex-direction: column; align-items: flex-start; padding: 0 20px;">
    <label for="remarks-ta" style="font-weight: 500; font-size: 14px; margin-bottom: 4px;">
      Internal Remarks
    </label>
    <textarea id="remarks-ta" class="swal2-textarea reject-note-ta" placeholder="Enter remarks" style="margin: 0; width: 100%;"></textarea></div>
  `,
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/success.png'),
        imageWidth: 80,
        imageHeight: 80,
        imageAlt: 'Custom Icon',
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonText: 'Yes, proceed',
        cancelButtonText: 'No, go back',
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-primary',
        },
        buttonsStyling: false,
        preConfirm: () => {
          const textarea = document.getElementById('remarks-ta')
          const inputValue = textarea.value
          const errorContainer = document.getElementById('swal-approve-error')

          if (!inputValue || inputValue.trim() === '') {
            textarea.classList.add('swal-input-error')
            if (!errorContainer) {
              const errorEl = document.createElement('small')
              errorEl.id = 'swal-approve-error'
              errorEl.style.cssText = 'display: block; color: #d91b35; text-align: left; padding: 4px 20px 0;'
              errorEl.innerText = 'Remarks are required to approve the request.'
              textarea.parentNode.insertAdjacentElement('afterend', errorEl)
            }
            return false
          }

          textarea.classList.remove('swal-input-error')
          if (errorContainer) errorContainer.remove()

          return inputValue
        },
      })
        .then(result => {
          if (result.value) {
            this.internalRemarks = result.value
            this.updateChange('approved')
          }
        })
    },

    async resolveImageUrl() {
      if (this.request.signatureFileStorage) {
        const response = await this.$http.get(
          `front-end/file/get/${this.request.signatureFileStorage}`,
          {
            responseType: 'blob',
          },
        )

        const blob = new Blob([response.data], {
          type: response.headers['content-type'],
        })
        const url = window.URL.createObjectURL(blob)

        this.imageUrl = url
      } else if (this.request.signature) {
        this.imageUrl = this.request.signature
      }
    },
    getVariant(key) {
      if (key % 4 === 0) return 'info'
      if (key % 4 === 1) return 'warning'
      if (key % 4 === 2) return 'danger'
      if (key % 4 === 3) return 'purple'
      return 'primary'
    },

    rejectRequest() {
      this.internalRemarks = this.request.internalRemarks
      this.$swal({
        title: 'Are you sure you want to reject this request?',
        html: `
    <p class="mb-1">Once you reject this request <strong>${this.request.stringID},</strong><br>customer will be informed.</p>
    <div style="display: flex; flex-direction: column; align-items: flex-start; padding: 0 20px;">
    <label for="remarks-ta-reject" style="font-weight: 500; font-size: 14px; margin-bottom: 4px;">
      Internal Remarks
    </label>
    <textarea id="remarks-ta-reject" class="swal2-textarea reject-note-ta" placeholder="Enter remarks" style="margin: 0; width: 100%;"></textarea></div>
  `,
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/file-cross.png'),
        imageWidth: 80,
        imageHeight: 80,
        imageAlt: 'Custom Icon',
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonText: 'Yes, reject request',
        cancelButtonText: 'No, go back',
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-primary',
        },
        buttonsStyling: false,
        preConfirm: () => {
          const textarea = document.getElementById('remarks-ta-reject')
          const inputValue = textarea.value
          const errorContainer = document.getElementById('swal-reject-error')

          if (!inputValue || inputValue.trim() === '') {
            textarea.classList.add('swal-input-error')
            if (!errorContainer) {
              const errorEl = document.createElement('small')
              errorEl.id = 'swal-reject-error'
              errorEl.style.cssText = 'display: block; color: #d91b35; text-align: left; padding: 4px 20px 0;'
              errorEl.innerText = 'Remarks are required to reject the request.'
              textarea.parentNode.insertAdjacentElement('afterend', errorEl)
            }
            return false
          }

          textarea.classList.remove('swal-input-error')
          if (errorContainer) errorContainer.remove()

          return inputValue
        },
      })
        .then(result => {
          if (result.value) {
            this.internalRemarks = result.value
            this.updateChange('rejected')
          }
        })
    },
    withdrawRequest() {
      this.internalRemarks = this.request.internalRemarks
      this.$swal({
        title: 'Are you sure you want to withdraw this request on behalf of the original purchaser?',
        html: `
    <p class="mb-1">Once you withdraw this request <strong>${this.request.stringID},</strong><br>customer will be informed.</p>
    <div style="display: flex; flex-direction: column; align-items: flex-start; padding: 0 20px;">
    <label for="remarks-ta-withdraw" style="font-weight: 500; font-size: 14px; margin-bottom: 4px;">
      Internal Remarks
    </label>
    <textarea id="remarks-ta-withdraw" class="swal2-textarea reject-note-ta" placeholder="Enter remarks" style="margin: 0; width: 100%;"></textarea></div>
  `,
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/rotate.png'),
        imageWidth: 80,
        imageHeight: 80,
        imageAlt: 'Custom Icon',
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonText: 'Yes, withdraw request',
        cancelButtonText: 'No, go back',
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-primary',
        },
        buttonsStyling: false,
        preConfirm: () => {
          const textarea = document.getElementById('remarks-ta-withdraw')
          const inputValue = textarea.value
          const errorContainer = document.getElementById('swal-withdraw-error')

          if (!inputValue || inputValue.trim() === '') {
            textarea.classList.add('swal-input-error')
            if (!errorContainer) {
              const errorEl = document.createElement('small')
              errorEl.id = 'swal-withdraw-error'
              errorEl.style.cssText = 'display: block; color: #d91b35; text-align: left; padding: 4px 20px 0;'
              errorEl.innerText = 'Remarks are required to withdraw the request.'
              textarea.parentNode.insertAdjacentElement('afterend', errorEl)
            }
            return false
          }

          textarea.classList.remove('swal-input-error')
          if (errorContainer) errorContainer.remove()

          return inputValue
        },
      })
        .then(result => {
          if (result.value) {
            this.internalRemarks = result.value
            this.updateChange('withdrawn')
          }
        })
    },
    resolveAcronymName(name) {
      return name.split(' ').map(item => item.charAt(0)).join('').toUpperCase()
    },

    updateChange(status) {
      let title = ''
      let postUrl = ''
      let toastContent = ''
      let toastIcon = ''
      let toastVariant = ''
      let customIcon = null
      if (status === 'approved') {
        title = `You've approved ${this.request.stringID}`
        toastContent = `${this.request.newPurchaser.name} has been approved as the new purchaser for File No. <strong>${this.request.fileNo} – ${this.request.nvsFileType} (${this.request.lotLocation}).</strong>`
        toastIcon = 'CheckCircleIcon'
        toastVariant = 'success'
        postUrl = `customer/file-transfer/${this.$route.params.id}/approve`
      } else if (status === 'rejected') {
        title = `You've rejected ${this.request.stringID}`
        toastContent = `The ${this.titleText} for File No. <strong>${this.request.fileNo} – ${this.request.nvsFileType} (${this.request.lotLocation})</strong> has been rejected.`
        toastIcon = 'FileMinusIcon'
        // eslint-disable-next-line global-require
        customIcon = require('@/assets/images/icons/file-cross.png')
        toastVariant = 'danger'
        postUrl = `customer/file-transfer/${this.$route.params.id}/reject`
      } else if (status === 'withdrawn') {
        title = `You've withdrawn ${this.request.stringID}`
        toastContent = `The ${this.titleText} for File No. <strong>${this.request.fileNo} – ${this.request.nvsFileType} (${this.request.lotLocation})</strong> has been withdrawn by OP.`
        toastIcon = 'RotateCcwIcon'
        toastVariant = 'info'
        postUrl = `customer/file-transfer/${this.$route.params.id}/withdraw`
      }
      const formData = new FormData()
      formData.append('status', status)
      formData.append('internalRemarks', this.internalRemarks)

      this.$http.post(postUrl, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(response => {
          if (response.data.success) {
            this.request = response.data.data
            this.transferDetailActivityLogs = response.data.data.activityLog.sort((a, b) => new Date(b.time) - new Date(a.time))
            this.$toast({
              component: ToastificationContentCustom,
              props: {
                title,
                text: toastContent,
                icon: toastIcon,
                customIcon,
                variant: toastVariant,
                hideClose: true,
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    resolveFileStatusVariant(status) {
      if (status === 'OPEN') return 'warning'
      if (status === 'BOOK') return 'info'
      return 'success'
    },
    resolvePaymentStatusVariant(status) {
      if (status === 'Fully Paid') return 'success'
      if (status === 'Ongoing Installment') return 'info'
      if (status === 'Pending Payment') return 'warning'
      if (status === 'Reactivation Fee') return 'danger'
      return 'secondary'
    },
    removeAttachment(name, id) {
      this.$http
        .post('customer/file-transfer/attachment/remove', { id, name, requestID: this.$route.params.id })
        .then(response => {
          this.transferAttachments = response.data.data.attachments.filter(file => file.fileStorage)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.data.message || '',
              icon: 'AlertTriangleIcon',
              variant: 'success',
            },
          })
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message || '',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    setAttachment(e) {
      if (e.target.files.length) {
        const acceptedTypes = ['image/jpeg', 'image/png', 'application/pdf']
        e.target.files.forEach(element => {
          if (acceptedTypes.includes(element.type)) {
            if (element.size > 20 * 1024 * 1024) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Can't add files more than 20mb",
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              })
            } else {
              const fileObj = {}
              fileObj.name = element.name
              fileObj.data = element
              fileObj.size = (element.size / (1024 * 1024)).toFixed(2)
              fileObj.type = element.type
              fileObj.description = ''
              fileObj.storage = 'local'
              this.attachments.push(fileObj)
            }
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Unsupported file type',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
      }
    },
    async uploadFile() {
      store.commit('appConfig/UPDATE_CONTINUOUS_LOADER', true)
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < this.attachments.length; i++) {
        // eslint-disable-next-line no-await-in-loop
        const res = await this.uploadFileToAws(this.attachments[i].data)
        const { fileUrl, fileName, upload } = res
        const formData = new FormData()
        if (upload && fileUrl) {
          this.attachments[i].data = fileName
          this.attachments[i].storage = 'aws'
          formData.append('sAttachments', JSON.stringify([this.attachments[i]]))
        } else {
          formData.append('attachments', this.attachments[i].data)
        }

        formData.append('shouldUpload', (upload && fileUrl))
        formData.append('requestID', this.$route.params.id)

        if (i === this.attachments.length - 1) {
          store.commit('appConfig/UPDATE_CONTINUOUS_LOADER', false)
        }

        this.$http.post('customer/file-transfer/attachment/upload', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
          .then(response => {
            this.transferAttachments = response.data.data.attachments.filter(file => file.fileStorage)
            // this.transferDetailActivityLogs = response.data.data.activityLog.sort((a, b) => new Date(b.time) - new Date(a.time))
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || '',
                icon: 'AlertTriangleIcon',
                variant: 'success',
              },
            })
          })
          .catch(error => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: error.data.message || '',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          })
      }

      this.attachments = []
    },
    async putFile() {
      let shouldUpload = true
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < this.attachments.length; i++) {
        // eslint-disable-next-line no-await-in-loop
        const res = await this.uploadFileToAws(this.attachments[i].data)
        shouldUpload = res.upload
        if (i === 0) {
          if (!shouldUpload) {
            break
          }
        }

        this.attachments[i].data = res.fileName
        this.attachments[i].storage = 'aws'
      }

      return { transferAttachments: this.attachments, shouldUpload }
    },
    closeDescriptionModal() {
      this.$root.$emit('bv::hide::modal', 'modal-attachment-description', '')
    },
    updateDescription(key) {
      this.attachmentKey = key
      this.description = this.transferAttachments[key].description
      this.$root.$emit('bv::show::modal', 'modal-attachment-description', '')
    },
    saveDescription() {
      const id = this.transferAttachments[this.attachmentKey]._id
      this.$http
        .post('customer/file-transfer/attachment/save-description', { id, description: this.description, requestID: this.$route.params.id })
        .then(response => {
          this.transferAttachments = response.data.data.attachments.filter(file => file.fileStorage)
          this.closeDescriptionModal()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.data.message || '',
              icon: 'AlertTriangleIcon',
              variant: 'success',
            },
          })
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message || '',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    openInternalRemarksEditModal() {
      this.internalRemarks = this.request.internalRemarks
      this.$root.$emit('bv::show::modal', 'modal-internal-remarks', '')
    },
    saveInternalRemarks() {
      this.$http
        .post('customer/file-transfer/save/internal-remarks', {
          remarks: this.internalRemarks,
          oldRemarks: this.request.internalRemarks,
          requestID: this.$route.params.id,
        })
        .then(response => {
          if (response.data.success) {
            this.request.internalRemarks = this.internalRemarks
            this.transferDetailActivityLogs = response.data.data.activityLog.sort((a, b) => new Date(b.time) - new Date(a.time))
            this.closeInternalRemarksModal()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || '',
                icon: 'AlertTriangleIcon',
                variant: 'success',
              },
            })
          } else {
            this.closeInternalRemarksModal()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || '',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message || '',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    closeInternalRemarksModal() {
      this.$root.$emit('bv::hide::modal', 'modal-internal-remarks', '')
    },

    async openEditModal() {
      this.$refs.update_user_modal.show()
      await this.$nextTick()
      this.npContact = this.request.newPurchaser.contact || '+65 '
      this.npEmail = this.request.newPurchaser.email || ''
      this.perAdd1 = this.request.npInformation.corAddress1
      this.perAdd2 = this.request.npInformation.corAddress2
      this.perPostcode = this.request.npInformation.corPostcode
      this.perCountry = this.request.npInformation.corCountry
    },
    submitEditForm(bvModalEvt) {
      bvModalEvt.preventDefault()
      this.$refs.customerEditForm.validate().then(success => {
        if (success) {
          this.$refs.update_user_modal.hide()
          this.$swal({
            title: 'Save current changes?',
            html: 'Your changes will overwrite the current information, are you sure?',
            // eslint-disable-next-line global-require
            imageUrl: require('@/assets/images/icons/warning.png'),
            imageWidth: 80,
            imageHeight: 80,
            imageAlt: 'Custom Icon',
            reverseButtons: true,
            showCancelButton: true,
            confirmButtonText: 'Yes, Save Changes',
            cancelButtonText: 'No, go back',
            customClass: {
              confirmButton: 'btn btn-primary ml-1',
              cancelButton: 'btn btn-outline-primary',
            },
            buttonsStyling: false,
          })
            .then(result => {
              if (result.value) {
                const formData = new FormData()
                formData.append('request', this.request._id)
                formData.append('contact', this.npContact)
                formData.append('email', this.npEmail)
                formData.append('corAdd1', this.perAdd1)
                formData.append('corAdd2', this.perAdd2)
                formData.append('corCountry', this.perCountry)
                formData.append('corPostcode', this.perPostcode)

                this.$http.post('customer/file-transfer/new-purchaser/overwrite', formData, {
                  headers: { 'Content-Type': 'multipart/form-data' },
                })
                  .then(response => {
                    if (response.data.success) {
                      this.request = response.data.data
                      this.transferDetailActivityLogs = response.data.data.activityLog.sort((a, b) => new Date(b.time) - new Date(a.time))
                      this.$swal({
                        title: 'Changes Saved',
                        html: '',
                        // eslint-disable-next-line global-require
                        imageUrl: require('@/assets/images/icons/success.png'),
                        imageWidth: 80,
                        imageHeight: 80,
                        imageAlt: 'Custom Icon',
                        showCancelButton: false,
                        confirmButtonText: 'Okay',
                        customClass: {
                          confirmButton: 'btn btn-primary',
                        },
                        buttonsStyling: false,
                      })
                    } else {
                      this.$toast({
                        component: ToastificationContent,
                        props: {
                          title: response.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                          icon: 'AlertTriangleIcon',
                          variant: 'danger',
                        },
                      })
                    }
                  })
                  .catch(error => {
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                      },
                    })
                  })
              }
            })
        }
      })
    },
  },
}
</script>

<style lang="scss">
  .per-page-selector {
    width: 90px;
  }
  .badge.light-font {
    font-weight: 400;
  }
  .modal-header.payment-status.front-modal {
    background: #21BB8B;
    padding: 24px 30px !important;
    button {
      background: rgba(255, 255, 255, 0.3) !important;
      margin-right: 20px !important;
      padding: 0;
      border-radius: 5px;
      min-width: 40px;
      width: 40px;
      line-height: 40px;
      height: 40px;
      position: relative;
    }
    h3 {
      font-size: 18px;
      line-height: 21px;
      color: #fff;
    }
    span.step-class {
      color: #fff !important;
      font-weight: 500;
      text-transform: uppercase;
      line-height: 23px;
      font-size: 12px;
      display: block;
    }
    .feather {
      vertical-align: text-bottom;
      color: #fff;
    }
  }
  .btn-success-without-button {
    border-color: #21BB8B !important;
    background-color: #21BB8B !important;
    color: #fff;
    &:hover {
      color: #fff;
    }
  }
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
